import freddiePic from "@/public/images/artists/freddie.png";
import { Artist } from "@/types/types";

export const freddie = {
  id: "213",
  name: "Freddie",
  image: freddiePic,
  description: `Freddie's voice is smooth with a slightly hoarse, airy tone, bringing a laid-back, soulful energy that effortlessly adapts to any style.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ffreddie-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Dance", "RnB", "Pop", "Folk"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Mid",
      },
      specific: {
        low: 46,
        high: 67,
      },
      sweetSpot: 56,
    },
  },
} as const satisfies Artist;
